import template from './navTabs.html';

export default function() {
  return {
    scope: {
      rules: '=',
      activeTab: '=',
    },
    controller: () => {},
    controllerAs: 'tabs',
    bindToController: true,
    templateUrl: template,
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/navTabs/navTabs.js
 **/